// src/index.tsx
import React from "react";
import { z } from "zod";
var SpacerPropsSchema = z.object({
  props: z.object({
    height: z.number().gte(0).optional().nullish()
  }).optional().nullable()
});
var SpacerPropsDefaults = {
  height: 16
};
function Spacer({ props }) {
  var _a;
  const style = {
    height: (_a = props == null ? void 0 : props.height) != null ? _a : SpacerPropsDefaults.height
  };
  return /* @__PURE__ */ React.createElement("div", { style });
}
export {
  Spacer,
  SpacerPropsDefaults,
  SpacerPropsSchema
};
